export default async function copyToClipboard(text) {
  var _navigator, _navigator$clipboard;

  if ((_navigator = navigator) != null && (_navigator$clipboard = _navigator.clipboard) != null && _navigator$clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (error) {
      console.error('Erro ao copiar para a área de transferência:', error);
      return false;
    }
  } // old browsers fallback


  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  let success = false;

  try {
    success = document.execCommand('copy');
  } catch (error) {
    console.error('Erro ao copiar o texto usando fallback:', error);
  }

  document.body.removeChild(textarea);
  return success;
}